<template>
  <a-card class="personalReport">
    <div class="search">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="报告名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.name" placeholder="请输入报告名称" />
        </a-form-model-item>
        <a-form-model-item label="机构名称">
          <a-select showSearch optionFilterProp="title" class="serach-item" allowClear v-model="searchForm.organizationId" placeholder="请选择机构名称">
            <a-select-option :value="item.id" :title="item.name" :key="item.id" v-for="item in organizationList">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select class="serach-item" allowClear v-model="searchForm.status" placeholder="请选择报告状态">
            <a-select-option :value="item.value" :key="item.value" v-for="item in statusList">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
          <a-button @click="searchReset" style="margin-left: 10px"> 重置 </a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`personalReport.Add`">
          <a-button @click="addReport" icon="plus" type="primary">添加报告</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div style="overflow: auto">
      <a-table
        style="min-width: 800px"
        :columns="columns"
        rowKey="id"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <div slot="status" slot-scope="text, record">
          <span v-if="text.status === 0" style="color: #409eff">配置中</span>
          <span v-else-if="text.status === 1" style="color: #e6a23c">待处理</span>
          <span v-else-if="text.status === 2" style="color: #e6a23c">生成中</span>
          <span v-else-if="text.status === 3" style="color: #67c23a">已生成</span>
          <span v-else-if="text.status === 4" style="color: red">生成失败</span>
        </div>
        <div slot="action" slot-scope="text, record">
          <a style="margin-right: 10px" v-permission="`personalReport.Edit`" href="javaScript:;">
            <span v-if="[0, 1, 2, 3, 6].includes(text.status)" @click="edit(text)"><a-icon type="edit" /> 编辑</span>
            <span v-else style="color: #ccc"><a-icon type="edit" /> 编辑</span>
          </a>
          <a-popconfirm title="确认删除此报告？" @confirm="del(text)" v-permission="`personalReport.Delete`">
            <a style="color: red; margin-right: 10px" href="javaScript:;">
              <a-icon type="delete" />
              删除</a
            >
          </a-popconfirm>
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-permission="`personalReport.Again`">
                <a href="javaScript:;" v-if="[1,2,3,4].includes(text.status)" @click="reload(text, 2)">重新生成</a>
                <a v-else style="color: #ccc" href="javaScript:;">重新生成</a>
              </a-menu-item>
              <a-menu-item v-permission="`personalReport.Download`">
                <a v-if="text.status === 3 && text.reportUri" download :href="text.reportUri | filterUrl">下载报告</a>
                <a v-else style="color: #ccc" href="javaScript:;">下载报告</a>
              </a-menu-item>
              <a-menu-item v-permission="`personalReport.Look`">
                <a @click="look(text)" href="javaScript:;" v-if="text.status === 3">查看详情</a>
                <a v-else style="color: #ccc" href="javaScript:;">查看详情</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-table>
    </div>
    <!--添加/编辑报告-->
    <a-modal v-model="modelForm.visible" :centered="true" :footer="null" width="100%" wrapClassName="create-report" @cancel="modelFormCancel" :destroyOnClose="true" :title="modelForm.title">
      <CreateReport :report-id="modelForm.id" />
    </a-modal>
    <!--查看报告详情-->
    <a-modal v-model="lookReport.visible" :centered="true" :footer="null" width="100%" wrapClassName="create-report" :destroyOnClose="true" title="报告详情">
      <LookReport :key="Date.now()" :report-info="lookReport.info" />
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import CreateReport from './createReport/CreateReport'
import $Bus from '@/pages/projectImpl/js/eventBus'
import LookReport from './lookReport/LookReport'

const columns = [
  {
    title: '报告名称',
    dataIndex: 'name',
  },
  {
    title: '机构名称',
    dataIndex: 'organizationName',
    ellipsis: true,
  },
  {
    title: '状态',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'personalReport',
  components: { CreateReport, LookReport },
  data() {
    return {
      columns,
      tableRelevant: tableRelevant.call(this),
      searchForm: {
        name: undefined,
        organizationId: undefined,
        status: undefined,
      },
      organizationList: [],
      statusList: [
        { name: '配置中', value: 0 },
        { name: '生成中', value: 2 },
        { name: '已生成', value: 3 },
      ],
      //添加、编辑报告相关
      modelForm: {
        visible: false,
        confirmLoading: false,
        title: '添加报告',
        id: '',
      },
      //查看报告
      lookReport: {
        visible: false,
        info: {},
      },
    }
  },
  created() {
    this.getOrganizationList()
    this.getPageList(1)
  },
  mounted() {
    $Bus.$on('closeCreateReport', () => {
      this.modelFormCancel()
    })
    $Bus.$on('copyReport', (id) => {
      this.modelForm.id = id
      this.modelForm.visible = true
      this.modelForm.title = '编辑报告'
      this.lookReport.visible = false
    })
  },
  methods: {
    //获取所有机构
    getOrganizationList() {
      this.$http.loadAllByType({ isOnlySuperior: false }).then((res) => {
        const { data } = res.data
        this.organizationList = data
      })
    },
    getPageList(pageIndex) {
      let params = {
        ...this.searchForm,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.$http.GroupReport.personalReportPageList(params).then((res) => {
        const { data } = res
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      })
    },
    //添加报告
    addReport() {
      this.modelForm.title = '添加报告'
      this.modelForm.id = ''
      this.$store.commit('organization/setReportInfo', {})
      this.modelForm.visible = true
      localStorage.setItem('handleType', 'add')
    },
    //编辑报告
    edit(val) {
      this.modelForm.title = '编辑报告'
      this.modelForm.id = val.id
      this.modelForm.visible = true
      localStorage.setItem('handleType', 'edit')
    },
    //添加编辑报告弹出框取消
    modelFormCancel() {
      const bool = this.modelForm.title === '添加报告'
      this.modelForm.visible = false
      this.modelForm.title = '添加报告'
      this.modelForm.id = ''
      this.$store.commit('organization/setReportInfo', {})
      if (bool) {
        this.getPageList(1)
      } else {
        this.getPageList()
      }
    },
    //查看报告详情
    look(val) {
      this.lookReport.info = val
      this.$store.commit('organization/setReportInfo', val)
      this.lookReport.visible = true
    },
    del(val) {
      this.tableRelevant.tableLoading = true
      const form = new FormData()
      form.append('id', val.id)
      this.$http.GroupReport.deletePersonalReport(form).then((res) => {
        this.$message.success('操作成功')
        this.getPageList(1)
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    reload(val) {
      this.$http.GroupReport.generateReport({
        id: val.id,
      }).then((res) => {
        const { message } = res
        this.$message.success(message)
        this.getPageList(1)
      })
    },
    //重置
    searchReset() {
      this.searchForm = {
        name: undefined,
        organizationId: undefined,
        status: undefined,
      }
      this.getPageList(1)
    },
  },
}
</script>

<style scoped>
.serach-item {
  width: 180px;
  margin-bottom: 15px;
}

>>> .create-report .ant-modal {
  width: 100%;
  height: 100%;
  padding-bottom: 0;
}

>>> .create-report .ant-modal-content {
  height: 100%;
  padding-bottom: 0;
}
</style>
